module.exports = __webpack_public_path__ + "static/media/logo-white.6e76a2b2.png";